import { render, staticRenderFns } from "./PagePreviewLoader.vue?vue&type=template&id=51b420dc&scoped=true"
import script from "./PagePreviewLoader.vue?vue&type=script&lang=js"
export * from "./PagePreviewLoader.vue?vue&type=script&lang=js"
import style0 from "./PagePreviewLoader.vue?vue&type=style&index=0&id=51b420dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b420dc",
  null
  
)

export default component.exports